import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { CourseService } from "../report-services/course.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { SectionService } from "../report-services/section.service";
import * as moment from "moment";

@Component({
	templateUrl: "./studentclassattendance.component.html",
})
export class StudentClassAttendanceComponent {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private homeroomService: HomeroomService,
		private courseService: CourseService,
		private sectionService: SectionService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		InstructorID: 0,
		HomeroomID: 0,
		GradeLevelID: 0,
		CourseID: 0,
		SectionID: 0,
		startDate: new Date(),
		endDate: new Date(),
		ImageLogo: "",
	};

	schoolList: any = [];
	instructorList: any = [];
	homeroomList: any = [];
	gradeList: any = [];
	sectionList: any = [];
	courseList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 252;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(252);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		this.HomeroomList();
		this.InstructorGetList();
		this.GradeList();
		this.CourseList();
		this.SectionList();
		this.loadLogolist();
	}

	onCourseChange(value) {
		this.report.CourseID = value;
	}

	private HomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.homeroomList = response;

				this.homeroomList.unshift({
					HomeroomId: 0,
					HomeRoom: "All Homerooms",
				});

				this.report.HomeroomID = this.homeroomList[0].HomeroomId;
			},
			(error) => {}
		);
	}

	private InstructorGetList() {
		this.report.InstructorID = 0;
		var result = this.reportService.InstructorGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.instructorList = response;

				this.instructorList.unshift({
					Teacher_PersonID: 0,
					Instructor: "All Instructors",
				});

				this.report.InstructorID = this.instructorList[0].Teacher_PersonID;
			},
			(error) => {}
		);
	}

	private GradeList() {
		this.report.GradeLevelID = 0;
		var result = this.reportService.GradesGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.gradeList = response;

				this.gradeList.unshift({
					GradeLevelID: 0,
					GradeLevelDesc: "All Grades",
				});

				this.report.GradeLevelID = this.gradeList[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	private CourseList() {
		this.report.CourseID = 0;
		var result = this.courseService.loadCourseList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.courseList = response;

				this.courseList.unshift({
					CourseID: 0,
					CourseDesc: "All Courses",
				});

				this.report.CourseID = this.courseList[0].CourseID;
			},
			(error) => {}
		);
	}

	private SectionList() {
		this.report.SectionID = 0;
		var result = this.sectionService.loadSectionNoList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.sectionList = response;

				this.sectionList.unshift({
					SectionID: 0,
					SectionDesc: "All Sections",
				});

				this.report.SectionID = this.sectionList[0].SectionID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 252;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam = this.report.SchoolID + "|SchoolID";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.HomeroomID + "|HomeroomID";
		strParam += "," + this.report.InstructorID + "|InstructorID";
		strParam += "," + this.report.CourseID + "|CourseID";
		strParam += "," + this.report.SectionID + "|SectionNo";

		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
